// oxlint-disable-next-line constellation/no-styled-factory -- ESLint's pandaLint set this warn-only; oxlint's oxlintPandaLint sets it error. Migrating this file's variant-based styled() usages to cva/sva is a real structural change, out of scope for this lint opt-in.
import { styled } from '@/styled-system/jsx';

import { Box } from '@zillow/constellation-10';

const footerHeight = '94px';

// Reusable variant configuration: Displays on mobile, hides at specified breakpoint
const mobileViewVariants = {
  showDesktopViewBreakpoint: {
    md: {
      md: {
        display: 'none',
      },
    },
    xl: {
      xl: {
        display: 'none',
      },
    },
    xxl: {
      xxl: {
        display: 'none',
      },
    },
  },
} as const;

// Reusable variant configuration: Hides on mobile, displays at specified breakpoint
const desktopViewVariants = {
  showDesktopViewBreakpoint: {
    md: {
      mdDown: {
        display: 'none',
      },
    },
    xl: {
      xlDown: {
        display: 'none',
      },
    },
    xxl: {
      xxlDown: {
        display: 'none',
      },
    },
  },
} as const;

// oxlint-disable-next-line constellation/no-styled-factory -- ESLint's pandaLint set this warn-only; oxlint's oxlintPandaLint sets it error, no code change
export const StyledWizardTipCardContainerMobile = styled(Box, {
  base: {
    display: 'block',
  },
  variants: mobileViewVariants,
});

// oxlint-disable-next-line constellation/no-styled-factory -- ESLint's pandaLint set this warn-only; oxlint's oxlintPandaLint sets it error, no code change
export const StyledWizardTipCardContainerDesktop = styled(Box, {
  base: {
    display: 'block',
  },
  variants: desktopViewVariants,
});

// oxlint-disable-next-line constellation/no-styled-factory -- ESLint's pandaLint set this warn-only; oxlint's oxlintPandaLint sets it error, no code change
export const StyledContentContainer = styled(Box, {
  base: {
    height: '100%',
    borderTop: '1px solid {colors.border.subtle}',
    borderBottom: 'none',
    overflowX: 'hidden',
    overflowY: 'auto',
    paddingInline: '400',
    lg: {
      paddingInline: '600',
      borderBottom: '1px solid {colors.border.subtle}',
      marginBottom: 0,
    },
    xxl: {
      paddingInline: '104px',
    },
    '& .content-grid': {
      maxWidth: '1232px',
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  variants: {
    hideFooter: {
      true: {},
      false: {
        marginBottom: footerHeight,
        lg: {
          marginBottom: 0,
        },
      },
    },
  },
});

// oxlint-disable-next-line constellation/no-styled-factory -- ESLint's pandaLint set this warn-only; oxlint's oxlintPandaLint sets it error, no code change
export const StyledWizardTipCardContainer = styled(Box, {
  base: {},
  variants: {
    showDesktopViewBreakpoint: {
      md: {
        md: {
          marginLeft: '105px',
        },
      },
      xl: {
        xl: {
          marginLeft: '105px',
        },
      },
      xxl: {
        xxl: {
          marginLeft: '105px',
        },
      },
    },
  },
});

// oxlint-disable-next-line constellation/no-styled-factory -- ESLint's pandaLint set this warn-only; oxlint's oxlintPandaLint sets it error, no code change
export const StyledMobileGrid = styled(Box, {
  base: {
    display: 'grid',
    gridColumnEnd: 'span 12',
    paddingTop: '600',
    paddingBottom: '200',
    borderTop: '1px solid {colors.border.subtle}',
  },
  variants: mobileViewVariants,
});

// oxlint-disable-next-line constellation/no-styled-factory -- ESLint's pandaLint set this warn-only; oxlint's oxlintPandaLint sets it error, no code change
export const StyledDesktopContainer = styled(Box, {
  base: {
    display: 'block',
    marginTop: '600',
    marginBottom: '1400',
  },
  variants: desktopViewVariants,
});

// oxlint-disable-next-line constellation/no-styled-factory -- ESLint's pandaLint set this warn-only; oxlint's oxlintPandaLint sets it error, no code change
export const StyledHeaderContainer = styled(Box, {
  base: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBlock: { base: '400', md: '600' },
  },
  variants: {
    showDesktopViewBreakpoint: {
      md: {
        paddingInline: { base: '400', md: '104px' },
      },
      xl: {
        paddingInline: { base: '400', md: '600', xl: '104px' },
      },
      xxl: {
        paddingInline: { base: '400', md: '600', xxl: '104px' },
      },
    },
  },
});
